export default __webpack_public_path__ + "static/media/like.c6c725b7.svg";